import debounce from 'lodash/debounce';
import { useDispatch } from 'react-redux';
import { CountBadge } from 'palette/Filters';
import { ListItem } from 'palette/List';
import { Toggle } from 'palette/Toggle';
import { toggleFilter } from '@common/Filters/actions/filtersActions';
import { useTranslation } from '@common/Hooks/useTranslation';

import '../styles/BrandsListItem.scss';

export function BrandsListItem({
    item
}) {
    const dispatch = useDispatch();
    const translate = useTranslation();
    const {
        name,
        count,
        isSelected
    } = item;

    const clickHandler = debounce((event) => {
        event.preventDefault();
        dispatch(toggleFilter(item));
    }, 250, {
        leading: true,
        trailing: false
    });

    return (
        <ListItem
            key={name}
            className="brands-list-item__list-item"
            isActive={isSelected}
            rightContent={(<CountBadge count={count} />)}
            onClick={clickHandler}
        >
            <Toggle
                id={name}
                isChecked={isSelected}
                label={translate(name)}
            />
        </ListItem>
    );
}
